<template>
  <div class="content">
    <b-container class="bv-example-row">
      <b-row>
        <b-col><router-link to="/base">基本設定</router-link></b-col>
        <b-col><router-link to="/area">エリア</router-link></b-col>
        <b-col><router-link to="/main-action">メイン行動</router-link></b-col>
        <b-col><router-link to="/test">テストプレー</router-link></b-col>
      </b-row>
      <b-row>
        <b-col><router-link to="/rule">法則</router-link></b-col>
        <b-col><router-link to="/card">カード</router-link></b-col>
        <b-col 
          ><router-link to="/buff">異常状態</router-link></b-col>
        <b-col><router-link to="/achievement">スタンプ</router-link></b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'world-nav',
  props: {
    id: String
  }
}
</script>

<style lang="scss" scoped>
.bv-example-row {
  div div {
    border: 2px solid #CCC;
  }
}
.router-link-exact-active {
  font-weight: bold;
}
</style>
